export const COINGECKO_PRICE_URL = 'https://api.coingecko.com/api/v3/simple/price';

export const NATIVE_TOKEN_COINGECKO_IDS: Record<string, string> = {
  ETH: 'ethereum',
  WETH: 'weth',
  MATIC: 'matic-network',
  POL: 'matic-network',
  BNB: 'binancecoin',
  AVAX: 'avalanche-2',
  FTM: 'fantom',
  CRO: 'crypto-com-chain',
  ONE: 'harmony',
  CELO: 'celo',
  GLMR: 'moonbeam',
  MOVR: 'moonriver',
  METIS: 'metis-token',
  OP: 'optimism',
  ARB: 'arbitrum',
  KAS: 'kaspa',
  SOL: 'solana',
  DAI: 'dai',
  USDC: 'usd-coin',
  USDT: 'tether',
};
